/*jshint esnext: true */
/*global jQuery, dis */

/* DIS/PLAY Script
 Author's name: Lars Munkholm
 Modified by:
 Client name: Danske Regioner
 Date of creation: 8.3.2016
 */


(function ($, dis) {
	"use strict";


	dis.Vac = function (objectConfiguration) {
		dis.BaseModule.call(this);

		var defaults = {},
			configuration = $.extend(defaults, objectConfiguration),
			dom = {},
			selfScope = this;

			dom.body = document.body;
			dom.searchInput = document.getElementById("main-search-input");
			// dom.searchTrigger = document.getElementById("main-search__trigger");



		// function getNextFocusElement(prev = false){
		// 	//add all elements we want to include in our selection
		// 	var focussableElements = 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, *[tabindex], *[contenteditable]';
		// 	var focussable = Array.prototype.filter.call(document.querySelectorAll(focussableElements),
		// 		function (element) {
		// 			//check for visibility while always include the current activeElement
		// 			return element.offsetWidth > 0 || element.offsetHeight > 0 || element === document.activeElement;
		// 		});
		//
		//
		// 	var index = focussable.indexOf(document.activeElement);
		//
		// 	console.log(index);
		// 	if(index === -1)
		// 	{
		// 		index = 0;
		// 	}
		//
		// 	console.log(focussable);
		// 	console.log(focussable[index]);
		//
		// 	if(index > -1) {
		// 		var nextElement = focussable[(!prev ? index + 1 : index - 1)] || focussable[0];
		// 		nextElement.focus();
		// 		return nextElement;
		// 	}
		// }
		//
		//
		// function triggerSearch(nextEl = null)
		// {
		// 	if(nextEl === dom.searchInput)
		// 	{
		// 		dom.body.classList.add("search-open");
		// 		dom.searchTrigger.checked = true;
		// 	}
		// 	else
		// 	{
		// 		dom.body.classList.remove("search-open");
		// 		dom.searchTrigger.checked = false;
		// 	}
		// }

		function init() {




			//if search-input get focused
			dom.container = $(configuration.container);

			var searchinputElement = document.getElementById("main-search-input");

			if(searchinputElement !== null)
			{
				searchinputElement.addEventListener('focus', () => {
					var body = document.body;

					window.setTimeout(() => {
						if(!body.classList.contains("search-open"))
						{
							body.classList.add("search-open");
							dom.searchTrigger.checked = true;
						}
					},10);
				});
			}

			// if (dom.container.length) {
			// 	dom.container.keydown(function(event) {
			//
			// 		if(event.shiftKey && event.key === 'Tab'){
			// 			var nextEl = getNextFocusElement(true);
			// 			console.log(nextEl);
			//
			// 			if(nextEl !== undefined)
			// 			{
			// 				console.log("preventDefault");
			// 				// event.preventDefault();
			// 			}
			//
			// 			// triggerSearch(nextEl);
			// 		}
			// 		else if (event.key === 'Tab') {
			// 			var nextEl = getNextFocusElement();
			//
			// 			console.log(nextEl);
			//
			// 			if(nextEl !== undefined)
			// 			{
			// 				event.preventDefault();
			// 			}
			//
			// 			// triggerSearch(nextEl);
			// 		}
			// 	});
			// }
		}

		selfScope.onReady(init);
	};

	dis.Vac.prototype = new dis.BaseModule();
	dis.Vac.constructor = dis.Vac;


// This is where you define the global parameters you pass into your closure. You'll want to pass in any
// big stuff you'll need inside your script. Minor stuff can always be accessed through window.someVariable.
}(jQuery, dis));